// @ts-nocheck
import styled from '@emotion/styled';

import { colors, fonts } from '../../styles';

export const Display = styled('div')`
  font-size: ${fonts.size.largest};
  font-weight: ${fonts.weight.bold};
  color: ${colors.black};
  line-height: 1.21;
`;
